import wrapWithProvider from './wrap-with-provider'
export const wrapRootElement = ({ element }) => {
  return wrapWithProvider({ element, wayup: process.env.WAYUP })
}
